<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          Image (required):
          <br />
          <span class="disclaimer">Allowed dimensions: 1080x1080 or 1080x1920.</span>
          <br />
          <span class="disclaimer">Max file size: 5 MB. Formats: JPG, PNG.</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [type]="'link'"
            [isPlainText]="true"
            (handleOnChange)="onChange($event, 'Image')"
            [blockData]="block.variables?.['Image'] ?? ''"
            [maxLength]="4000"
            variable="Image"
            [blockId]="block.blockId"
            [isImage]="true"
          ></app-block-text>
        </div>
      </div>
    </div>
  </div>
</main>
